import { SET_CURRENT_TENANT_PRICING_PLAN } from "../actionTypes/pricingPlansActionTypes";

const initialState = {
  pricingPlans: [],
  currentTenant: null,
};
const pricingPlans = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_TENANT_PRICING_PLAN:
      return {
        ...state,
        currentTenant: action.payload,
      };
    default:
      return state;
  }
};

export default pricingPlans;
